// components/PdfDownloadBg.jsx
import React from 'react';
import { usePdf } from '../context/pdfContext';

const PdfDownloadBg = () => {
    const { activeDownloads } = usePdf();

    if (activeDownloads.length === 0) return null;

    return (
        <div style={styles.wrapper}>
            {activeDownloads.map((download) => (
                <div key={download.id} style={{
                    ...styles.card,
                    borderLeft: download.status === 'error' ? '4px solid #f44336' :
                        download.status === 'success' ? '4px solid #4caf50' : '4px solid #2196f3'
                }}>
                    <div style={styles.info}>
                        <span style={styles.name}>{download.name}</span>
                        <span style={styles.status}>
                            {download.status === 'loading' && 'Generating PDF...'}
                            {download.status === 'success' && 'Download Complete!'}
                            {download.status === 'error' && 'Error!'}
                        </span>
                    </div>
                    {download.status === 'loading' && <div style={styles.spinner} />}
                </div>
            ))}
        </div>
    );
};

const styles = {
    wrapper: {
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
    },
    card: {
        background: '#fff',
        padding: '12px 20px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        display: 'flex',
        alignItems: 'center',
        gap: '15px',
        borderLeft: '4px solid #2196F3'
    },
    name: { fontWeight: 'bold', fontSize: '14px', display: 'block' },
    status: { fontSize: '12px', color: '#666' },
    spinner: {
        width: '15px',
        height: '15px',
        border: '2px solid #f3f3f3',
        borderTop: '2px solid #2196F3',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
    }
};

export default PdfDownloadBg;